import PropTypes from 'prop-types';

import LeadersCard from '../cards/leadersCard';
import { pipe } from '../../utils/helpers';

const Leadership = ({ text, team }) => {
	const mapToLeaderCard = (item) => ({
		...item,
		title: item?.name,
		subtitle: item?.role,
		body: item?.description?.childMarkdownRemark?.html,
		image: item?.photo?.gatsbyImageData,
		imageAlt: item?.photo?.description,
	});

	return (
		<div className="leaders section">
			<div className="section__content">
				<h2 className="leaders__title typography typography--h2 typography--secondary">
					{text}
				</h2>
				<div className="leaders__items">
					{team.map(
						pipe(mapToLeaderCard, (leader) => (
							<LeadersCard key={leader.id} leader={leader} />
						))
					)}
				</div>
			</div>
		</div>
	);
};

Leadership.propTypes = {
	text: PropTypes.string.isRequired,
	team: PropTypes.arrayOf(
		PropTypes.shape({
			id: PropTypes.string.isRequired,
			description: {
				childMarkdownRemark: PropTypes.object,
			},
			name: PropTypes.string.isRequired,
			role: PropTypes.string.isRequired,
			photo: {
				gatsbyImageData: PropTypes.object,
				description: PropTypes.string,
			},
		})
	),
};

Leadership.defaultProps = {
	text: '',
	team: [],
};

export default Leadership;
